/**
 * @packageDocumentation
 * @module      SystemTesterConfig.ts
 * @description Configuration for System Tester tests - easily modify tests without touching component logic
 * @copyright   Copyright © 2025 Siemens Healthineers. All rights reserved.
 */
export const TEST_CONFIGURATIONS = [
    {
        name: "Start Setup",
        startMessage: "Starting System Tester Tests",
        instruction: 'Follow the "Test Setup" section of the Work Instruction. Confirm that the test setup is correct before starting.',
        images: ['./assets/img/Exclamation.png'],
    },
    {
        name: "Initialization",
        startMessage: 'Started test "Initialization"',
        instruction: 'Follow the "Initialization" section of the Work Instructions.',
        images: ['./assets/img/Initialization.png'],
    },
    {
        name: "Consumables Setup - Procedure Workflow",
        startMessage: 'Started test "Consumables Setup"',
        instruction: 'Follow the "Cassette Attach Test" section of the Work Instruction.',
        images: ['./assets/img/Cassette.png'],
    },
    {
        name: "Attach to Patient - Procedure Workflow",
        startMessage: 'Started test "Attach to Patient"',
        instruction: 'Follow the "Drive Lock & Unlock Test" section of the Work Instruction.',
        images: ['./assets/img/DriveButton.png'],
    },
    {
        name: "Arm Unlock/Lock",
        startMessage: 'Started test "Arm Unlock/Lock"',
        instruction: 'Follow the "Arm Lock & Unlock Test" section of the Work Instruction.',
        images: ['./assets/img/ArmButton.png'],
    },
    {
        name: "PIM Control",
        startMessage: 'Started test "PIM Control"',
        instruction: 'Follow the "PIM Control" section of the Work Instruction.',
        images: ['./assets/img/PIM.png'],
    },
    {
        name: "ESTOP",
        startMessage: 'Started test "ESTOP"',
        instruction: 'Follow the "ESTOP Test" section of the Work Instruction.',
        images: ['./assets/img/ESTOP.png'],
    },
    {
        name: "Rumble",
        startMessage: 'Started test "Rumble"',
        instruction: 'Follow the "Rumble Test" section of the Work Instruction.',
        images: ['./assets/img/tensionIcon.svg', './assets/img/compressionIcon.svg'],
    },
    {
        name: "Tear-Down",
        startMessage: 'Started test "Tear-Down"',
        instruction: 'Follow the "Tear-Down" section of the Work Instruction.',
        images: ['./assets/img/TearDown.png'],
    },
    {
        name: "Homing - Automated Moves",
        startMessage: 'Started test "Homing - Automated Moves"',
        instruction: 'Follow the "Automated Moves" section of the Work Instruction.',
        images: ['./assets/img/Exclamation.png'],
    },
    {
        name: "End Testing",
        startMessage: 'Full System Tester Finished',
        instruction: 'Follow the "End Testing" section of the Work Instruction. Once that section has been completed, please close this test application.',
        images: ['./assets/img/DownloadData.png'],
    }
];
//# sourceMappingURL=SystemTesterConfig.js.map